import { Injectable } from '@angular/core';
import { TenantConfig, TenantFeatures, TenantSupportConfig } from './tenant-config.model';
import { TENANTS } from './tenants';
import { resolveTenantId } from './resolve-tenant-id';

@Injectable({
  providedIn: 'root',
})
export class TenantService {
  readonly current: TenantConfig =
    TENANTS[resolveTenantId(window.location.hostname, window.location.search)];

  constructor() {
    const gradient = this.current.primaryColorEnd
      ? `linear-gradient(135deg, ${this.current.primaryColor}, ${this.current.primaryColorEnd})`
      : this.current.primaryColor;
    document.documentElement.style.setProperty('--brand-primary-color', this.current.primaryColor);
    document.documentElement.style.setProperty('--brand-gradient', gradient);
  }

  get features(): TenantFeatures {
    return this.current.features;
  }

  get support(): TenantSupportConfig {
    return this.current.support;
  }
}
